import { render, staticRenderFns } from "./EditActions.vue?vue&type=template&id=52be56f5&"
import script from "./EditActions.vue?vue&type=script&lang=js&"
export * from "./EditActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports